import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/app.css';
import { AppRouter } from './AppRouter';
import { ThemeProvider } from '@/Components/ThemeProvider';

createRoot(document.getElementById('app')!).render(
    <StrictMode>
        <ThemeProvider>
            <BrowserRouter>
                <AppRouter />
            </BrowserRouter>
        </ThemeProvider>
    </StrictMode>,
);
